<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <div class="bg-white pd-10">
      <!-- 返回按钮 -->
      <div
        class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
        @click="$router.push('/waterCard/cardList')"
      >
        <i class="el-icon-arrow-left fw-600"></i>
        返回
      </div>
      <!-- 基本信息 -->
      <div class="mgt-30 fw-600 mgb-10">基本信息</div>
      <el-table stripe border :data="tableData" style="width: 100%">
        <el-table-column prop="cardId" label="水卡编号"> </el-table-column>
        <el-table-column prop="cardType" label="水卡类型">
          <template slot-scope="scope">
            <span
              v-text="
                scope.row.cardType == 2
                  ? '实物卡'
                  : scope.row.cardType == 1
                  ? '电子卡'
                  : scope.row.cardType == 3
                  ? '时效电子卡'
                  : '时效实物卡'
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column prop="status" label="是否绑定">
          <template slot-scope="scope">
            <span v-text="scope.row.status == 1 ? '是' : '否'"></span>
          </template>
        </el-table-column>
        <el-table-column prop="customerName" label="用户昵称">
          <template slot-scope="scope">
            <span
              v-text="scope.row.cardName ? scope.row.cardName : '--'"
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="userId" label="用户ID"> </el-table-column>
        <el-table-column prop="customerPhone" label="客户电话">
          <template slot-scope="scope">
            <span
              v-text="scope.row.customerPhone ? scope.row.customerPhone : '--'"
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="customerPhone" label="归属企业">
          <template slot-scope="scope">
            <span
              v-text="scope.row.companyName ? scope.row.companyName : '--'"
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="customerPhone" label="水卡管理员工">
          <template slot-scope="scope">
            <span
              v-text="scope.row.userName ? scope.row.userName : '--'"
            ></span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="customerPhone" label="水卡来源">
          <template slot-scope="scope">
            <span
              v-text="scope.row.sourceName ? scope.row.sourceName : '--'"
            ></span>
          </template>
        </el-table-column> -->
      </el-table>

      <!-- 水卡信息 -->
      <div class="mgt-20">
        <div>水卡信息</div>
        <div class="mgt-10">
          <el-button
            v-if="
              data.status == 1 && data.cardStatus == 0 && data.cardType == 2
            "
            @click="report"
            >挂 失</el-button
          >
          <!-- <el-button
            v-if="
              data.status == 1 &&
                data.cardStatus == 0 &&
                data.sourceName !== '未来先生一'
            "
            @click="updateUser"
            >更新用户信息</el-button
          > -->
          <el-button
            v-if="data.cardStatus == 1 && data.cardType == 2"
            @click="clearReport"
            >解除挂失</el-button
          >

          <!-- <el-button
            v-if="
              data.cardStatus == 1 &&
                data.status == 1 &&
                data.sourceName !== '未来先生一'
            "
            @click="reCardBtn"
            >水卡迁移</el-button
          >
          <el-button
            v-if="data.status == 1 && data.sourceName !== '未来先生一'"
            @click="record"
            >迁移记录</el-button
          > -->
          <!-- <el-button
            v-if="
              data.status == 0 &&
                data.cardStatus == 0 &&
                data.sourceName !== '未来先生一' && data.cardType == 2
            "
            @click="bindCard"
            >绑 卡</el-button
          > -->
          <!-- <el-button
            v-if="
              data.status == 0 &&
                data.cardStatus == 0 &&
                data.sourceName !== '未来先生一' && data.cardType == 2
            "
            @click="del"
            >删 除</el-button
          > -->
          <!-- <el-button @click="lookbangjilu">绑定/解绑记录</el-button> -->
        </div>
        <div class="mgt-10">
          <el-button
            v-if="data.sourceName !== '未来先生一'"
            @click="qinglingjiluSure"
            >交易记录</el-button
          >
          <el-button @click="shareUser">共享用户</el-button>
          <el-button
            @click="getZhuan"
            v-if="
              Number(cardInfo.currentBalance) > 0 &&
                otherCard.length > 0 &&
                tableData[0].cardType !== 3 &&
                tableData[0].cardType !== 4
            "
            >余额转移</el-button
          >
        </div>
      </div>

      <!-- == -->
      <div class="mgt-20">
        <el-descriptions border :column="1">
          <el-descriptions-item label="充值次数">{{
            cardInfo.rechargeNum
          }}</el-descriptions-item>
          <el-descriptions-item label="充值总金额（赠送/实收）">
            <span
              v-text="
                cardInfo.totalBalance +
                  '(' +
                  cardInfo.totalBalanceSend +
                  '/' +
                  cardInfo.totalBalancePay +
                  ')'
              "
            ></span>
          </el-descriptions-item>
          <el-descriptions-item label="消费次数">{{
            cardInfo.orderNum !== null &&
            cardInfo.orderNum !== undefined &&
            cardInfo_ro.orderNum !== null &&
            cardInfo_ro.orderNum !== undefined
              ? cardInfo.orderNum + cardInfo_ro.orderNum
              : 0
          }}</el-descriptions-item>
          <el-descriptions-item label="已消费金额（赠送/实收）">
            <span
              v-text="
                (cardInfo.usedBalance + cardInfo_ro.usedBalance).toFixed(2) +
                  '(' +
                  (
                    cardInfo.usedBalanceSend + cardInfo_ro.usedBalanceSend
                  ).toFixed(2) +
                  '/' +
                  (
                    cardInfo.usedBalancePay + cardInfo_ro.usedBalancePay
                  ).toFixed(2) +
                  ')'
              "
            ></span>
          </el-descriptions-item>
          <el-descriptions-item label="水卡余额（赠送/实收）">
            <span
              v-text="
                cardInfo.currentBalance +
                  '(' +
                  cardInfo.currentBalanceSend +
                  '/' +
                  cardInfo.currentBalancePay +
                  ')'
              "
            ></span>
          </el-descriptions-item>
          <el-descriptions-item label="失效时间">{{
            cardInfo.outTime ? cardInfo.outTime : "- -"
          }}</el-descriptions-item>
          <el-descriptions-item label="总取水量（L）">{{
            cardInfo.totalWaterVolume !== null &&
            cardInfo.totalWaterVolume !== undefined &&
            cardInfo_ro.totalWaterVolume !== null &&
            cardInfo_ro.totalWaterVolume !== undefined
              ? (
                  cardInfo.totalWaterVolume / 1000 +
                  cardInfo_ro.totalWaterVolume / 1000
                ).toFixed(3)
              : 0
          }}</el-descriptions-item>
          <el-descriptions-item label="本月取水量（L）">{{
            cardInfo.monthWaterVolume !== null &&
            cardInfo.monthWaterVolume !== undefined &&
            cardInfo_ro.monthWaterVolume !== null &&
            cardInfo_ro.monthWaterVolume !== undefined
              ? (
                  cardInfo.monthWaterVolume / 1000 +
                  cardInfo_ro.monthWaterVolume / 1000
                ).toFixed(3)
              : 0
          }}</el-descriptions-item>
          <el-descriptions-item label="最后一次取水时间">{{
            cardInfo.lastTime &&
            (cardInfo_ro.lastTime == null || cardInfo_ro.lastTime == undefined)
              ? cardInfo.lastTime
              : (cardInfo.lastTime == null || cardInfo.lastTime == undefined) &&
                cardInfo_ro.lastTime
              ? cardInfo_ro.lastTime
              : cardInfo.lastTime && cardInfo_ro.lastTime
              ? getRecentTime(cardInfo.lastTime, cardInfo_ro.lastTime)
              : "- -"
          }}</el-descriptions-item>
          <el-descriptions-item label="水卡状态">
            <span
              v-text="
                data.cardStatus == 0
                  ? '正常'
                  : data.cardStatus == 1
                  ? '已挂失'
                  : data.cardStatus == 2
                  ? '异常'
                  : data.cardStatus == 3
                  ? '已失效'
                  : '- -'
              "
            ></span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>

    <!-- 绑卡弹框 -->
    <el-dialog
      title="水卡绑定"
      :visible.sync="bindVisible"
      width="30%"
      @close="bindForm = {}"
      center
      :close-on-click-modal="false"
    >
      <el-form
        ref="bindForm"
        :rules="bindFormRules"
        :model="bindForm"
        label-width="80px"
      >
        <el-form-item label="水卡编号">
          <el-input v-model="bindForm.num" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="客户电话" prop="phone">
          <el-input
            v-model="bindForm.phone"
            placeholder="请输入水卡绑定客户电话"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="bindVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindBtn('bindForm')"
          >水卡绑定</el-button
        >
      </span>
    </el-dialog>

    <!-- 更新用户信息弹框 -->
    <el-dialog
      title="更新用户信息"
      :visible.sync="updateUserFormVisible"
      width="30%"
      @close="updateUserForm = {}"
      center
      :close-on-click-modal="false"
    >
      <el-form
        ref="updateUserForm"
        :rules="updateUserFormRules"
        :model="updateUserForm"
        label-width="80px"
      >
        <el-form-item label="水卡编号">
          <el-input v-model="updateUserForm.num" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="客户电话" prop="phone">
          <el-input
            v-model="updateUserForm.phone"
            placeholder="请输入水卡客户电话"
            @change="$forceUpdate()"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="updateUserFormVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="updateBtn('updateUserForm')"
          >信息更新</el-button
        >
      </span>
    </el-dialog>

    <!-- 水卡迁移弹框 -->
    <el-dialog
      title="水卡余额迁移"
      :visible.sync="reCardFormVisible"
      width="30%"
      @close="reCardForm = {}"
      center
      :close-on-click-modal="false"
    >
      <el-form ref="reCardForm" :model="reCardForm" label-width="80px">
        <el-form-item label="迁移金额">
          <el-input v-model="reCardForm.money" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item
          label="水卡"
          prop="card"
          :rules="[{ required: true, message: '请选择水卡', trigger: 'blur' }]"
        >
          <el-select
            filterable
            v-model="reCardForm.card"
            placeholder="请选择水卡"
          >
            <el-option
              v-for="v in cardArr"
              :key="v.id"
              :label="v.cardId"
              :value="v.cardId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="reCardFormVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="reCardSureBtn('reCardForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 迁移记录 -->
    <el-dialog
      title="水卡余额迁移记录"
      :visible.sync="recordVisible"
      width="40%"
      center
      :close-on-click-modal="false"
    >
      <el-table :data="recordtableData" style="width: 100%" stripe border>
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="cardNo" label="迁移卡号"> </el-table-column>
        <el-table-column prop="toCardNo" label="被迁移卡号"> </el-table-column>
        <el-table-column prop="cardMoney" label="迁移金额（元）">
        </el-table-column>
        <el-table-column prop="adminName" label="操作人"> </el-table-column>
        <el-table-column prop="createTime" label="迁移时间"> </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <el-pagination
        class="mgt-20"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 20, 30, 40, 50]"
        :page-size="pageSize"
        layout=" prev, pager, next"
        :total="total"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="recordVisible = false">已 知 晓</el-button>
      </span>
    </el-dialog>

    <!-- 水卡绑定记录 -->
    <el-dialog
      title="水卡绑定记录"
      :visible.sync="bangdingjiluVisible"
      width="40%"
      center
      :close-on-click-modal="false"
    >
      <el-table :data="bangdingTable" style="width: 100%" stripe border>
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="status" label="操作">
          <template slot-scope="scope">
            <span
              v-text="
                scope.row.status === 1
                  ? '绑定'
                  : scope.row.status === 2
                  ? '解绑'
                  : '- -'
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="电话">
          <template slot-scope="scope">
            <span v-text="scope.row.phone ? scope.row.phone : '- -'"></span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注"> </el-table-column>
        <el-table-column prop="createTime" label="时间"> </el-table-column>
        <el-table-column prop="userName" label="操作人"> </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <!-- <el-pagination
        class="mgt-20"
        background
        @size-change="handleSizeChange2"
        @current-change="handleCurrentChange2"
        :current-page="page2"
        :page-sizes="[5, 20, 30, 40, 50]"
        :page-size="pageSize2"
        layout=" prev, pager, next"
        :total="total2"
      >
      </el-pagination> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="bangdingjiluVisible = false">已 知 晓</el-button>
      </span>
    </el-dialog>

    <!-- 水卡清零记录 -->
    <el-dialog
      title="水卡交易记录"
      :visible.sync="qinglingjiluVisible"
      width="40%"
      center
      :close-on-click-modal="false"
    >
      <el-table :data="qinglingTable" style="width: 100%" stripe border>
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="beforeBalance" label="交易前水卡余额(赠送/实付)">
          <template slot-scope="scope">
            <span>
              {{
                scope.row.beforeBalance +
                  "(" +
                  (scope.row.beforeBalanceSend !== null &&
                  scope.row.beforeBalanceSend !== undefined
                    ? scope.row.beforeBalanceSend
                    : "- -") +
                  "/" +
                  (scope.row.beforeBalancePay !== null &&
                  scope.row.beforeBalancePay !== undefined
                    ? scope.row.beforeBalancePay
                    : "- -") +
                  ")"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="afterBalance" label="交易后水卡余额(赠送/实付)">
          <template slot-scope="scope">
            <span>
              {{
                scope.row.afterBalance +
                  "(" +
                  (scope.row.afterBalanceSend !== null &&
                  scope.row.afterBalanceSend !== undefined
                    ? scope.row.afterBalanceSend
                    : "- -") +
                  "/" +
                  (scope.row.afterBalancePay !== null &&
                  scope.row.afterBalancePay !== undefined
                    ? scope.row.afterBalancePay
                    : "- -") +
                  ")"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="message" label="交易描述"> </el-table-column>

        <el-table-column prop="remark" label="备注">
          <template slot-scope="scope">
            <span v-text="scope.row.remark ? scope.row.remark : '- -'"></span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="时间"> </el-table-column>
        <el-table-column prop="adminName" label="操作人">
          <template slot-scope="scope">
            <span
              v-text="scope.row.adminName ? scope.row.adminName : '- -'"
            ></span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <el-pagination
        class="mgt-20"
        background
        @size-change="handleSizeChange3"
        @current-change="handleCurrentChange3"
        :current-page="page3"
        :page-sizes="[5, 20, 30, 40, 50]"
        :page-size="pageSize3"
        layout=" prev, pager, next"
        :total="total3"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="qinglingjiluVisible = false">已 知 晓</el-button>
      </span>
    </el-dialog>

    <!-- 共享用户弹框 -->
    <el-dialog
      title="水卡共享信息"
      :visible.sync="gongxiangVisible"
      width="40%"
      center
      :close-on-click-modal="false"
    >
      <el-table :data="gongxiangTable" style="width: 100%" stripe border>
        <el-table-column
          type="index"
          :index="indexMethod9"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="userName" label="昵称"> </el-table-column>
        <el-table-column prop="userPhone" label="用户电话"> </el-table-column>
        <el-table-column prop="createTime" label="分享时间"> </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <!-- <el-pagination
        class="mgt-20"
        background
        @size-change="handleSizeChange8"
        @current-change="handleCurrentChange8"
        :current-page="page8"
        :page-sizes="[5, 20, 30, 40, 50]"
        :page-size="pageSize8"
        layout=" prev, pager, next"
        :total="total8"
      >
      </el-pagination> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="gongxiangVisible = false">已 知 晓</el-button>
      </span>
    </el-dialog>

    <!-- 余额转移弹框 -->
    <el-dialog
      title="余额转移"
      :visible.sync="moneyZhuanVisible"
      width="30%"
      center
      :close-on-click-modal="false"
    >
      <el-form
        :rules="zhuanFormRules"
        ref="zhuanForm"
        :model="zhuanForm"
        label-width="110px"
      >
        <el-form-item label="水卡编号">
          <el-input disabled v-model="zhuanForm.cardNo"></el-input>
        </el-form-item>
        <el-form-item label="转移金额(元)" prop="money">
          <el-input
            v-model="zhuanForm.money"
            :placeholder="
              `请输入转移金额，当前最多可转移${cardInfo.currentBalance}元`
            "
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <span>余额转移优先转移实付金额</span>
        </el-form-item>

        <el-form-item label="接收水卡" prop="toCardNo">
          <el-select v-model="zhuanForm.toCardNo" placeholder="请选择接收水卡">
            <el-option
              v-for="(v, i) in otherCard"
              :key="i"
              :label="
                v.walletCard +
                  '（' +
                  (v.server == 1
                    ? '社区售水机'
                    : v.server == 2
                    ? '楼宇单元售水机'
                    : v.server == 3
                    ? '家用净水器'
                    : '- -') +
                  '）'
              "
              :value="v.walletCard"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <span>仅相同区域中同一用户的水卡支持余额转移</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="moneyZhuanVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="afterSure('zhuanForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    const bindPhone = (rule, value, callback) => {
      var reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!value) {
        callback(new Error("请填写客户电话"));
      } else if (!reg.test(value)) {
        callback(new Error("手机号格式不正确，请重新输入"));
      } else {
        callback();
      }
    };
    const money = (rule, value, callback) => {
      var reg = /^\d+(.\d{1,2})?$/;
      if (!value) {
        callback(new Error("请输入金额"));
      } else if (
        !reg.test(value) ||
        Number(value) > Number(this.cardInfo.currentBalance)
      ) {
        callback(new Error("仅支持数字输入，且金额不能大于当前水卡余额"));
      } else {
        callback();
      }
    };
    return {
      bangdingjiluVisible: false,
      bangdingTable: [],
      qinglingjiluVisible: false,
      qinglingTable: [],
      tableData: [],
      data: null,
      cardInfo: {
        totalBalance: 0,
        totalBalanceSend: 0,
        totalBalancePay: 0,
        usedBalance: 0,
        usedBalanceSend: 0,
        usedBalancePay: 0,
        currentBalance: 0,
        currentBalanceSend: 0,
        currentBalancePay: 0,
      },
      cardInfo_ro: {
        totalBalance: 0,
        totalBalanceSend: 0,
        totalBalancePay: 0,
        usedBalance: 0,
        usedBalanceSend: 0,
        usedBalancePay: 0,
        currentBalance: 0,
        currentBalanceSend: 0,
        currentBalancePay: 0,
      },
      bindForm: {
        num: "",
        phone: "",
      },
      bindVisible: false,
      bindFormRules: {
        phone: [{ required: true, validator: bindPhone, trigger: "blur" }],
      },
      zhuanFormRules: {
        money: [{ required: true, validator: money, trigger: "blur" }],
        toCardNo: [{ required: true, message: "请选择水卡", trigger: "blur" }],
      },
      updateUserFormVisible: false,
      updateUserForm: {
        num: "",
        phone: "",
      },
      updateUserFormRules: {
        phone: [{ required: true, validator: bindPhone, trigger: "blur" }],
      },
      reCardForm: {
        money: "",
        card: "",
      },
      reCardFormVisible: false,
      recordVisible: false,
      recordtableData: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 5, //每页显示多少条数据，默认
      total: 50, // 数据总条数

      // 分页数据
      page2: 1, // 当前页，默认
      pageSize2: 5, //每页显示多少条数据，默认
      total2: 50, // 数据总条数

      // 分页数据
      page3: 1, // 当前页，默认
      pageSize3: 5, //每页显示多少条数据，默认
      total3: 50, // 数据总条数
      cardArr: [],
      // 共享弹框
      gongxiangVisible: false,
      gongxiangTable: [],
      // 分页数据
      page8: 1, // 当前页，默认
      pageSize8: 5, //每页显示多少条数据，默认
      total8: 50, // 数据总条数
      moneyZhuanVisible: false,
      zhuanForm: {
        cardNo: "",
        money: "",
        toCardNo: "",
      },
      otherCard: [],
    };
  },
  created() {
    this.data = this.$route.query.data;

    this.getUserInfo();

    this.getMoneyInfo();
    this.getMoneyInfo_ro();
    this.getCardOtherPull();
  },
  methods: {
    // 比较最后一次取水时间，售水机和厨下
    getRecentTime(a, b) {
      // 将时间字符串转换为 Date 对象
      const date1 = new Date(a);
      const date2 = new Date(b);

      // 比较两个时间
      if (date1 > date2) {
        return a;
      } else {
        return b;
      }
    },
    afterSure(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm("确认转移吗?", "info")
            .then(() => {
              this.$api.waterCard
                .moneyPass({
                  cardNo: this.zhuanForm.cardNo,
                  money: this.zhuanForm.money,
                  toCardNo: this.zhuanForm.toCardNo,
                  cardNoServer: 1,
                  toCardNoServer: 1,
                })
                .then((res) => {
                  if (res.code === 200) {
                    handleAlert("余额转移成功", "success");
                    this.moneyZhuanVisible = false;
                    this.getUserInfo();
                    this.getMoneyInfo();
                    this.getMoneyInfo_ro();
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },
    getZhuan() {
      this.getCardOtherPull();

      this.zhuanForm = {
        cardNo: this.data.cardId,
        money: this.cardInfo.currentBalance,
        toCardNo: "",
      };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.zhuanForm.clearValidate();
      });
      this.moneyZhuanVisible = true;
    },
    getCardOtherPull() {
      // this.$api.waterCard.queryCard({ cardId: this.data.id }).then((res) => {
      //   if (res.code === 200) {
      //     this.otherCard = [];
      //     res.data.forEach((v) => {
      //       if (v.cardType !== 3 && v.cardType !== 4) {
      //         this.otherCard.push(v);
      //       }
      //     });
      //   }
      // });
      if(!this.data.customerPhone){
        return;
      }


      Promise.all([
        this.$api.waterCard.waterCardListSsj({
          companyId: this.data.companyId,
          regionId: this.data.regionId,
          phone: this.data.customerPhone,
        }),
        this.$api.waterCard.waterCardListRo({
          companyId: this.data.companyId,
          regionId: this.data.regionId,
          phone: this.data.customerPhone,
        }),
        ])
        .then(([res1, res2, res3]) => {
          const result = [
            ...res1.data.map((item) => ({ ...item, server: 1 })),
            ...res2.data.map((item) => ({ ...item, server: 3 })),
          ];

          this.otherCard = result.filter(
            (item) =>
              item.walletCard !== this.data.cardId &&
              item.isShare !== true &&
              item.status == 0 &&
              item.type !== 4 &&
              item.type !== 3
          );
          console.log(this.otherCard, "this.otherCard ");

        })
        .catch((error) => {
          console.error("Error while fetching data:", error);
        });



      // 构建请求数组
// const requests = [];

// // 只有 customerPhone 存在时才添加第一个请求
// if (this.data.customerPhone) {
//   requests.push(
//     this.$api.waterCard.waterCardListSsj({
//       companyId: this.data.companyId,
//       regionId: this.data.regionId,
//       phone: this.data.customerPhone,
//     })
//   );
// }

// // 第二个请求总是添加
// requests.push(
//   this.$api.waterCard.waterCardListRo({
//     companyId: this.data.companyId,
//     regionId: this.data.regionId,
//     phone: this.data.customerPhone, // 即使 phone 为 undefined 也可以传
//   })
// );

// console.log('发了几个请求', requests.length);

// Promise.all(requests)
//   .then((responses) => {
//     let result = [];
    
//     // 根据请求的数量处理响应
//     if (this.data.customerPhone) {
//       // 有 customerPhone：两个请求都发送了
//       const [res1, res2] = responses;
//       result = [
//         ...res1.data.map((item) => ({ ...item, server: 1 })),
//         ...res2.data.map((item) => ({ ...item, server: 3 })),
//       ];
//     } else {
//       // 没有 customerPhone：只发送了第二个请求
//       const [res2] = responses;
//       result = [
//         ...res2.data.map((item) => ({ ...item, server: 3 })),
//       ];
//     }

//     this.otherCard = result.filter(
//       (item) =>
//         item.walletCard !== this.data.cardId &&
//         item.isShare !== true &&
//         item.status == 0 &&
//         item.type !== 4 &&
//         item.type !== 3
//     );
//     console.log(this.otherCard, "this.otherCard ");
//   })
//   .catch((error) => {
//     console.error("Error while fetching data:", error);
//   });
    },
    getShare() {
      this.$api.waterCard
        .cardShareList({ cardId: this.tableData[0].cardId })
        .then((res) => {
          if (res.code === 200) {
            this.gongxiangTable = res.data;
          }
        });
    },
    // 共享用户按钮
    shareUser() {
      this.gongxiangVisible = true;
      this.getShare();
    },
    qinglingjiluSure() {
      this.$api.waterCard
        .qinglingjilu({
          walletCard: this.data.cardId,
          pageNum: this.page3,
          pageSize: this.pageSize3,
        })
        .then((res) => {
          if (res.code === 200) {
            this.qinglingTable = res.data.rows;
            this.total3 = res.data.total;
            this.qinglingjiluVisible = true;
          }
        });
    },
    lookbangjilu() {
      this.$api.waterCard
        .unbindjilu({ cardId: this.data.cardId })
        .then((res) => {
          if (res.code === 200) {
            this.bangdingTable = res.data;
            this.bangdingjiluVisible = true;
          }
        });
    },
    // 下拉水卡
    getPull() {
      this.$api.waterCard
        .cardPull({
          companyId: this.tableData[0].userId,
          cardNo: this.data.cardId,
        })
        .then((res) => {
          if (res.code === 200) {
            this.cardArr = res.data;
          }
        });
    },
    // 绑定弹框
    bindBtn(f) {
      this.$refs[f].validate((valid) => {
        if (valid) {
          handleConfirm(
            `确认将水卡绑定至用户（${this.bindForm.phone}）吗？`,
            "info"
          )
            .then(() => {
              this.$api.waterCard
                .cardBind({
                  cardNum: this.bindForm.num,
                  phone: this.bindForm.phone,
                  id: this.data.id,
                  userCardId: this.data.userCardId,
                })
                .then((res) => {
                  if (res.code === 200) {
                    handleAlert("绑定成功", "success");
                    this.bindVisible = false;
                    this.getUserInfo();
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },

    del() {
      handleConfirm(`确认删除该水卡吗？`, "info")
        .then(() => {
          this.$api.waterCard
            .cardDel({ cardNo: this.data.cardId })
            .then((res) => {
              if (res.code === 200) {
                handleAlert("水卡已删除", "success");
                this.$router.push("/waterCard/cardList");
              }
            });
        })
        .catch(() => {
          return;
        });
    },

    // 更新用户信息
    updateBtn(f) {
      this.$refs[f].validate((valid) => {
        if (valid) {
          if (this.updateUserForm.phone !== this.tableData[0].customerPhone) {
            handleConfirm(
              `确认将水卡更新至用户（${this.updateUserForm.phone}）吗？`,
              "info"
            )
              .then(() => {
                this.$api.waterCard
                  .cardBind({
                    cardNum: this.updateUserForm.num,
                    phone: this.updateUserForm.phone,
                    id: this.data.id,
                    userCardId: this.data.userCardId,
                  })
                  .then((res) => {
                    if (res.code === 200) {
                      handleAlert("用户信息更新成功", "success");
                      this.updateUserFormVisible = false;
                      this.getUserInfo();
                    }
                  });
              })
              .catch(() => {
                return;
              });
          } else {
            this.updateUserFormVisible = false;
          }
        } else {
          return false;
        }
      });
    },

    // 挂失
    report() {
      handleConfirm(`挂失后水卡将不可用，确定挂失卡片吗？`, "info")
        .then(() => {
          let arr = [
            {
              id: this.data.id,
              cardId: this.data.cardId,
              lostStatus: "lost",
              sourceName: this.data.sourceName,
            },
          ];

          this.$api.waterCard.guashiAll(arr).then((res) => {
            if (res.code === 200) {
              handleAlert("水卡已挂失", "success");
              this.getMoneyInfo();
              this.getUserInfo();
              this.getMoneyInfo_ro();
            }
          });
        })
        .catch(() => {
          return;
        });
    },

    // hpt挂失
    reporthpt() {
      handleConfirm(`挂失后水卡将不可用，确定挂失卡片吗？`, "info")
        .then(() => {
          this.$api.waterCard
            .hptLost({ cardId: this.data.cardId, status: "lost" })
            .then((res) => {
              if (res.code === 200) {
                handleAlert("水卡已挂失", "success");
                this.getMoneyInfo();
                this.getUserInfo();
                this.getMoneyInfo_ro();
              }
            });
        })
        .catch(() => {
          return;
        });
    },

    // 迁移
    reCardBtn() {
      this.reCardFormVisible = true;
      this.getPull();
      this.reCardForm.money = this.cardInfo.currentBalance;
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.reCardForm.clearValidate();
      });
    },

    // 迁移
    reCardSureBtn(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          if (this.reCardForm.money == 0) {
            handleAlert("水卡无余额，无法迁移", "error");
          } else {
            handleConfirm(`确认迁移水卡吗？`, "info")
              .then(() => {
                this.$api.waterCard
                  .transfer({
                    cardNo: this.data.cardId,
                    toCardNo: this.reCardForm.card,
                  })
                  .then((res) => {
                    if (res.code === 200) {
                      handleAlert("水卡已迁移", "success");
                      this.reCardFormVisible = false;
                      this.getMoneyInfo();
                      this.getUserInfo();
                      this.getMoneyInfo_ro();
                    }
                  });
              })
              .catch(() => {
                return;
              });
          }
        } else {
          return false;
        }
      });
    },

    // 迁移记录
    record() {
      this.recordVisible = true;
      this.getRecord();
    },

    // 记录
    getRecord() {
      this.$api.waterCard
        .shiftRecord({
          cardNo: this.data.cardId,
          pageNum: this.page,
          pageSize: this.pageSize,
        })
        .then((d) => {
          if (d.code === 200) {
            this.recordtableData = d.data.rows;
            this.total = d.data.total;
          }
        });
    },

    // 解除挂失
    clearReport() {
      handleConfirm(`水卡解除挂失后可恢复使用，确定解除吗？`, "info")
        .then(() => {
          let arr = [
            {
              id: this.data.id,
              cardId: this.data.cardId,
              lostStatus: "normal",
              sourceName: this.data.sourceName,
            },
          ];
          this.$api.waterCard.guashiAll(arr).then((res) => {
            if (res.code === 200) {
              handleAlert("水卡已解除挂失", "success");
              this.getMoneyInfo();
              this.getUserInfo();
              this.getMoneyInfo_ro();
            }
          });
        })
        .catch(() => {
          return;
        });
    },

    // hpt解除挂失
    clearReporthpt() {
      handleConfirm(`水卡解除挂失后可恢复使用，确定解除吗？`, "info")
        .then(() => {
          let normal = "normal";
          this.$api.waterCard
            .hptLost({ cardId: this.data.cardId, status: normal })
            .then((res) => {
              if (res.code === 200) {
                handleAlert("水卡已解除挂失", "success");
                this.getMoneyInfo();
                this.getUserInfo();
                this.getMoneyInfo_ro();
              }
            });
        })
        .catch(() => {
          return;
        });
    },

    bindCard() {
      this.bindVisible = true;
      this.bindForm.num = this.data.cardId;
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.bindForm.clearValidate();
      });
    },

    updateUser() {
      this.updateUserFormVisible = true;
      // this.updateUserForm.num = this.data.cardId;
      // this.updateUserForm.phone = JSON.parse(
      //   JSON.stringify(this.tableData[0].customerPhone)
      // );
      this.updateUserForm = {
        num: JSON.parse(JSON.stringify(this.tableData[0].cardId)),
        phone: JSON.parse(JSON.stringify(this.tableData[0].customerPhone)),
      };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.updateUserForm.clearValidate();
      });
    },

    getUserInfo() {
      this.$api.waterCard
        .userInfo({
          id: this.data.id,
          cardId: this.data.cardId,
          sourceId: this.data.sourceId,
        })
        .then((d) => {
          if (d.code === 200) {
            this.tableData = [];
            this.tableData.push(d.data);
            this.data = d.data;
          }
        });
    },

    getMoneyInfo() {
      this.$api.waterCard
        .cardMoneyInfo({ walletCard: this.data.cardId })
        .then((res) => {
          if (res.code === 200) {
            this.cardInfo = res.data;
          }
        });
    },
    getMoneyInfo_ro() {
      this.cardInfo_ro = {
        currentBalance: 0,
        currentBalancePay: 0,
        currentBalanceSend: 0,
        expireBalance: 0,
        expireBalancePay: 0,
        expireBalanceSend: 0,
        isTimePackage: 0,
        isTop: false,
        lastTime: null,
        monthWaterVolume: 0,
        orderNum: 0,
        outBalance: 0,
        outBalancePay: 0,
        outBalanceSend: 0,
        rechargeNum: 0,
        totalBalance: 0,
        totalBalancePay: 0,
        totalBalanceSend: 0,
        totalWaterVolume: 0,
        usedBalance: 0,
        usedBalancePay: 0,
        usedBalanceSend: 0,
      };
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    //表格序号，根据索引+1
    indexMethod9(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getRecord();
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getRecord();
    },

    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange8(val) {
      this.pageSize8 = val;
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange8(val) {
      this.page8 = val;
    },

    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange2(val) {
      this.pageSize = val;
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange2(val) {
      this.page = val;
    },

    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange3(val) {
      this.pageSize3 = val;
      this.qinglingjiluSure(this.page3);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange3(val) {
      this.page3 = val;
      this.qinglingjiluSure(this.page3);
    },
  },
};
</script>

<style lang="scss" scoped></style>
